import { observable, computed, action, runInAction } from 'mobx';
import AgentResource from './agent-resource';
import WatchAgentResource from './watchagent-resource';
import AgentLookupResource from './agent-lookup-resource';
import WatchAgentModel from './watchagent-model';
import _ from 'lodash';

export default class AgentStore {
    lookupAgents = observable.array();
    @observable fileAgents = [];
    @observable watchAgents = [];
    appStore;

    constructor(appStore) {
        this.appStore = appStore;
        this.agentResource = new AgentResource();
        this.agentLookupResource = new AgentLookupResource();
        this.watchAgentsResource = new WatchAgentResource();
    }

    @computed
    get combinedAgents() {
        return _.sortBy(
            _.unionWith(this.fileAgents.slice(), this.watchAgents.slice(), (a, b) => {
                return a.agentContactId === b.agentContactId;
            }),
            x => x.name
        );
    }

    @computed
    get combinedAgentsForAdmin() {
        let fileAgents = this.fileAgents.slice().concat(this.watchAgents.slice());
        let groupAgents = [];
        _.each(fileAgents, agent => {
            let foundAgent = _.find(groupAgents, { agentContactId: agent.agentContactId });
            if (foundAgent) {
                const isWatchAgent = agent instanceof WatchAgentModel;
                if (isWatchAgent) {
                    foundAgent.fileWatchCoordinatorNames.push(agent.coordinator.name);
                    if (agent.coordinator.coordinatorId === appStore.coordinatorDetailStore.coordinator.coordinatorId) {
                        foundAgent.coordinatorId = agent.coordinator.coordinatorId;

                        foundAgent.watchAgentId = agent.watchAgentId;
                        foundAgent.watching = true;
                    }
                } else {
                    foundAgent.preferredEmail = !_.isEmpty(agent.preferredEmail) ? agent.preferredEmail : null;
                    foundAgent.fileCoordinatorNames.push(agent.coordinatorName);
                }
            } else {
                const isWatchAgent = agent instanceof WatchAgentModel;
                agent.fileCoordinatorNames = [];
                agent.fileWatchCoordinatorNames = [];
                if (isWatchAgent) {
                    agent.fileWatchCoordinatorNames.push(agent.coordinator.name);
                    if (agent.coordinator.coordinatorId === appStore.coordinatorDetailStore.coordinator.coordinatorId) {
                        agent.coordinatorId = agent.coordinator.coordinatorId;
                        agent.preferredEmail = agent.agentProfile ? agent.agentProfile.preferredEmail : '';
                        agent.watching = true;
                    }
                } else {
                    agent.fileCoordinatorNames.push(agent.coordinatorName);
                }
                groupAgents.push(_.clone(agent));
            }
        });
        return groupAgents;
    }

    @computed
    get lookupAgentsComputed() {
        return this.lookupAgents.map(e => {
            return {
                agentContactId: e.ContactId,
                name: e.Name,
                email: e.Email,
                firstName: e.FirstName,
                lastName: e.LastName,
                company: e.Company || '',
                subscriberId: e.SubscriberId,
            };
        });
    }

    @action.bound
    loadLookupAgents(query) {
        if (query.lastIndexOf('.') === query.length - 1) return; //Skip query ending in .

        this.agentLookupResource.getAgents(this.appStore.authStore.getAccessToken(), query).then(agents => {
            this.lookupAgents.replace(agents['agent-lookups']);
        });
    }

    @action.bound
    loadAgents(ids) {
        const formattedQuery = { filter: { where: { tcFileId: { inq: ids } } } };

        this.agentResource.getAgentsSearch(this.appStore.authStore.getAccessToken(), formattedQuery).then(agents => {
            return agents;
        });
    }

    @action.bound
    loadFileAgents() {
        this.agentResource
            .getFileAgents(
                this.appStore.authStore.getAccessToken(),
                appStore.coordinatorDetailStore.coordinator.coordinatorId
            )
            .then(agents => {
                this.fileAgents.replace(agents);
            });
    }

    @action.bound
    loadWatchAgents() {
        if (this.appStore.coordinatorDetailStore.isAdmin() || this.appStore.coordinatorDetailStore.isSales()) {
            this.watchAgentsResource.getWatchAgents(this.appStore.authStore.getAccessToken()).then(watchAgents => {
                this.watchAgents.replace(watchAgents);
            });
        } else {
            this.watchAgentsResource
                .getWatchAgentsByCoordinatorId(
                    this.appStore.authStore.getAccessToken(),
                    appStore.coordinatorDetailStore.coordinator.coordinatorId
                )
                .then(watchAgents => {
                    this.watchAgents.replace(watchAgents);
                });
        }
    }

    @action.bound
    removeWatchAgent(agent) {
        return this.watchAgentsResource.deleteById(this.appStore.authStore.getAccessToken(), agent.watchAgentId);
    }

    @action.bound
    addWatchAgent(agent) {
        if (
            this.watchAgents.some(
                watchAgent =>
                    watchAgent.agentContactId === agent.agentContactId &&
                    watchAgent.coordinatorId === this.appStore.coordinatorDetailStore.coordinator.coordinatorId
            )
        ) {
            return Promise.reject(new Error(`You are already watching ${agent.name}`));
        } else {
            agent.subscriberName = agent.company || 'Not found';
            return this.watchAgentsResource.post(this.appStore.authStore.getAccessToken(), agent);
        }
    }
}



// WEBPACK FOOTER //
// ./src/agents/agent-store.js